module.exports = new __parcel__URL__("darkdamage.313bd36a.png").toString();